// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as IntegrationComponent} from './Integration.svg';

import Icon, { TIconProps } from '../Icon';

export const IconIntegration = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <IntegrationComponent/>
  </Icon>
));
